// extracted by mini-css-extract-plugin
export default {"recommendationsDrawer__itemsWrapper":"styles_recommendations-drawer__items-wrapper__MCu3X","recommendationsDrawer__buttons":"styles_recommendations-drawer__buttons__CJYOF"};